<div class="resume-info-step-container">

    <div *ngIf="LoadingSimulation">
        <div>
            <p-skeleton [width]="'100%'" [height]="'48px'"></p-skeleton>
        </div>

        <div style="margin-top: 15px;">
            <p-skeleton [width]="'100%'" [height]="'460px'"></p-skeleton>
        </div>
    </div>


    <div class="contact-title" *ngIf="!LoadingSimulation">
        <img src="/assets/icons/new-service-user.svg" alt="User icon" />
        <span>
            {{'EDIT_SERVICES.RESUME_INFO.0' | translate}}
        </span>
    </div>

    <div class="card-container" *ngIf="ServiceForm && !LoadingSimulation">
        <div class="card-title">
            {{'EDIT_SERVICES.RESUME_INFO.1' | translate}}
        </div>
        <div class="address-container">
            <div class="address-icon-container">
                <app-address-line-icon></app-address-line-icon>
            </div>
            <div>
                <div class="address-title">
                    {{'EDIT_SERVICES.RESUME_INFO.2' | translate}}
                </div>
                <div class="address-name">
                    {{originAddressValue}}
                </div>
                <div class="date-service">
                    {{formattedStartDate}}
                </div>

                <div class="address-title" style="margin-top: 15px;">
                    {{'EDIT_SERVICES.RESUME_INFO.3' | translate}}
                </div>
                <div class="address-name">
                    {{destinationAddressValue}}
                </div>
                <div class="date-service">
                    {{formattedEndDate}}
                </div>

            </div>
        </div>

        <div class="split"></div>

        <div class="contact-container">
            <div class="address-title">
                {{pickupContactSamePerson ? ('EDIT_SERVICES.RESUME_INFO.11' | translate) :
                ('EDIT_SERVICES.RESUME_INFO.12' | translate)}}
            </div>

            <div>
                <div class="contact-name" style="margin-top: 4px;">
                    {{originContactName}}
                    {{originContactLastName}}
                </div>
                <div class="contact-text" style="margin-top: 4px;">
                    {{originContactPhoneNumber}}
                </div>
                <div class="contact-text">
                    {{originContactEmail}}
                </div>
                <div class="contact-text" style="margin-top: 4px;">
                    {{originContactIsContactParticular ? 'Particular' : 'Corporativo'}}
                </div>
            </div>

            <div *ngIf="!pickupContactSamePerson" style="margin-top: 15px;">
                <div class="address-title">
                    {{'EDIT_SERVICES.RESUME_INFO.4' | translate}}
                </div>
                <div class="contact-name" style="margin-top: 4px;">
                    {{destinationContactName}}
                    {{destinationContactLastName}}
                </div>
                <div class="contact-text" style="margin-top: 4px;">
                    {{destinationContactPhoneNumber}}
                </div>
                <div class="contact-text">
                    {{destinationContactEmail}}
                </div>
                <div class="contact-text" style="margin-top: 4px;">
                    {{destinationContactIsContactParticular ? ('EDIT_SERVICES.RESUME_INFO.13' | translate) :
                    ('EDIT_SERVICES.RESUME_INFO.14' | translate)}}
                </div>
            </div>
        </div>

        <div class="comments-container" *ngIf="commetsServiceForm">
            <div class="split"></div>
            <div class="address-title">
                {{'EDIT_SERVICES.RESUME_INFO.5' | translate}}
            </div>
            <div class="contact-text" style="margin-top: 4px;">
                {{commetsServiceForm}}
            </div>
        </div>

        <div class="split"></div>

        <div class="price-container">
            <div class="contact-name" style="margin-top: 4px;">
                {{'EDIT_SERVICES.RESUME_INFO.6' | translate}}
            </div>

            <div class="price-rows-container">
                <div class="price-row" *ngFor="let product of Products.controls">
                    <div class="price-row-title">
                        <app-service-icons [isActiveRouteMap]="true"
                            [ServiceProductKey]="product.get('ProductKey')?.value"
                            [newServiceIcons]="true"></app-service-icons>
                        <span class="service_type_detail_text">{{
                            'PRODUCT_KEY_NAME.' + product.get('ProductKey')?.value | translate
                            }}</span>

                    </div>
                    <div class="price-row-value">
                        {{product.get('Amount')?.value | roundDecimals: 2 }}{{ServiceForm.get([FORM_KEYS.AddressData,
                        FORM_KEYS.OriginAddress, FORM_KEYS.ZoneId])?.value | CurrencyByZoneId}}
                    </div>
                </div>

                <div class="price-row" *ngFor="let fee of Fees.controls">
                    <ng-container *ngIf="fee.get('Amount')?.value">
                        <div class="price-row-title">
                            <p>{{fee.get('FeeKey')?.value | translate}}</p>
                        </div>
                        <div class="price-row-value">
                            {{fee.get('Amount')?.value | roundDecimals: 2}}{{ServiceForm.get([FORM_KEYS.AddressData,
                            FORM_KEYS.OriginAddress,
                            FORM_KEYS.ZoneId])?.value | CurrencyByZoneId}}
                        </div>
                    </ng-container>

                </div>

                <!-- <div class="price-row">
                    <div class="price-row-title">
                        <p>Tasa Cafler</p>
                    </div>
                    <div class="price-row-value">
                        15{{currencySymbol}}
                    </div>
                </div> -->

                <div class="price-row">
                    <div class="price-row-title">
                        <p>{{'EDIT_SERVICES.RESUME_INFO.7' | translate}} ({{TaxPercentageValue}}%)</p>
                    </div>
                    <div class="price-row-value">
                        {{TotalOrderTaxAmountValue | roundDecimals: 2}}{{ServiceForm.get([FORM_KEYS.AddressData,
                        FORM_KEYS.OriginAddress,
                        FORM_KEYS.ZoneId])?.value | CurrencyByZoneId}}
                    </div>
                </div>
            </div>

            <div class="split"></div>
            <div class="price-row row-bold">
                <div class="price-row-title">
                    <p>{{'EDIT_SERVICES.RESUME_INFO.8' | translate}}</p>
                </div>
                <div class="price-row-value">
                    <p>{{TotalOrderAmountValue | roundDecimals: 2}}{{ServiceForm.get([FORM_KEYS.AddressData,
                        FORM_KEYS.OriginAddress,
                        FORM_KEYS.ZoneId])?.value | CurrencyByZoneId}}</p>
                </div>
            </div>

            <div class="cancel-policy">
                {{'EDIT_SERVICES.RESUME_INFO.9' | translate}} <a
                    href="https://cafler.atlassian.net/wiki/external/M2E4YWE5ZDczYzViNGJmMzllNzg2MWRiNzczOGJkYTQ"
                    target="_blank" class="cancel-policy-link">{{'EDIT_SERVICES.RESUME_INFO.10' | translate}}</a>
            </div>

        </div>
    </div>
</div>